"use strict";
import {
  doConfigHooks,
  doConfigUnlockLevelRequirementHooks,
  doUTILSHooks,
} from "./hooks";
import notify from "./notify";

Object.defineProperty(Object.prototype, "copyToClipboard", {
  set(
    this: Krunker.Utils,
    copyToClipboard: Krunker.Utils["copyToClipboard"] | null,
  ) {
    if (!copyToClipboard) return;
    delete Object.prototype.copyToClipboard;
    this.copyToClipboard = copyToClipboard;
    doUTILSHooks(this);
  },
  configurable: true,
});

Object.defineProperty(Object.prototype, "regionNames", {
  set(this: Krunker.Config, value: Krunker.Config["regionNames"]) {
    delete Object.prototype.regionNames;
    this.regionNames = value;
    doConfigHooks(this);
    const isLocal = location.hostname === "127.0.0.1";
    const state = window.__krunkerConnectState;
    if (state?.matchmakerURL && state.socialURL && state.apiURL) {
      this.socialURL = state.socialURL;
      this.apiURL = state.apiURL;
      this.matchmakerURL = state.matchmakerURL;
    } else {
      this.socialURL = isLocal
        ? location.origin + "/api"
        : "https://api.krunker.zip";
      this.apiURL = isLocal
        ? location.origin + "/api"
        : "https://api.krunker.zip";
      this.matchmakerURL = isLocal
        ? location.origin + "/mm"
        : "https://matchmaker.krunker.zip";
    }
  },
  configurable: true,
});

Object.defineProperty(Object.prototype, "skinColors", {
  set(this: Krunker.Config, value: Krunker.Config["skinColors"]) {
    delete Object.prototype.skinColors;
    this.skinColors = value;
    doConfigUnlockLevelRequirementHooks(this);
  },
  configurable: true,
});

const eventsMap = new WeakMap<object, Krunker.IOEvents | undefined>();

Object.defineProperty(Object.prototype, "events", {
  get(this: Krunker.IO): Krunker.IOEvents | undefined {
    if (typeof this.connect === "function") window.io = this;
    return eventsMap.get(this);
  },
  set(this: Krunker.IO, value: Krunker.IOEvents | undefined) {
    // @ts-ignore
    this.broadcast = function () {};
    value.notify = notify;
    eventsMap.set(this, value);
  },
});
